import axios from 'axios'
import { The, createJsonData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

const workspace = getCurrentWorkspace()

export const emailServer = {
  create: (formData) =>
    The(
      axios.post(
        `${APIURL}/v4/email-servers/`,
        createJsonData(formData),
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  getAllAvailable: (formSlug, params = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/available-email-servers/`,
        config({ params, workspace })
      )
    ),

  getAll: (formSlug, params = {}) =>
    The(
      axios.get(`${APIURL}/v4/email-servers/`, config({ params, workspace }))
    ),

  update: (formData, serverSlug) =>
    The(
      axios.patch(
        `${APIURL}/v4/email-servers/${serverSlug}/`,
        createJsonData(formData),
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
}
